import { VARIABLE_CONDITION_OPERATORS } from '../conditions/variable-condition-operators';
export const PROVIDER_EVENT_COMPONENTS = [
    { value: 'voice', label: 'Voice' },
    { value: 'transcriber', label: 'Transcriber' },
    { value: 'model', label: 'Model' }
];
export const PROVIDER_EVENTS = [
    { value: 'errors', label: 'errors' },
    { value: 'fallbacks', label: 'fallbacks' }
];
export const PROVIDER_EVENT_OPERATORS = VARIABLE_CONDITION_OPERATORS.number.filter((o) => o.value !== 'exists' && o.value !== 'not-exists');
export const formatProviderEventsLabel = (c) => {
    const component = PROVIDER_EVENT_COMPONENTS.find((o) => o.value === c.component)?.label ?? c.component;
    const operator = PROVIDER_EVENT_OPERATORS.find((o) => o.value === c.operation)?.label ?? c.operation;
    return `${component} ${c.event} ${operator} ${c.value}`;
};
//# sourceMappingURL=provider-events.js.map